// extracted by mini-css-extract-plugin
module.exports = {"section":"TelephonySection_section__1I5se"};